import request from '@/utils/request'


// 查询退货订单列表
export function listRefund(query) {
  return request({
    url: '/biz/admin/order/refund/list',
    method: 'post',
    headers:{"repeatSubmit": false},
    data: query
  })
}

// 查询退货订单分页
export function pageRefund(query) {
  return request({
    url: '/biz/admin/order/refund/page',
    method: 'post',
    headers:{"repeatSubmit": false},
    data: query
  })
}

// 查询退货订单详细
export function getRefund(data) {
  return request({
    url: '/biz/admin/order/refund/detail',
    method: 'post',
    data: data
  })
}



// 新增退货订单
export function refundApply(data) {
  return request({
    url: '/biz/admin/order/refund/refund/apply',
    method: 'post',
    data: data
  })
}

export function freeApply(data) {
  return request({
    url: '/biz/admin/order/refund/free',
    method: 'post',
    data: data
  })
}

export function refundAmount(data) {
  return request({
    url: '/biz/admin/order/refund/refund/amount',
    method: 'post',
    data: data
  })
}


export function refundReceipt(data) {
  return request({
    url: '/biz/admin/order/refund/receipt',
    method: 'post',
    data: data
  })
}

// 新增退货订单
export function auditRefund(data) {
  return request({
    url: '/biz/admin/order/refund/audit',
    method: 'post',
    data: data
  })
}

export function auditRefundBatch(data) {
  return request({
    url: '/biz/admin/order/refund/audit/batch',
    method: 'post',
    data: data
  })
}

// 修改退货订单
export function updateRefund(data) {
  return request({
    url: '/biz/admin/order/refund/edit',
    method: 'post',
    data: data
  })
}

// 删除退货订单
export function delRefund(data) {
  return request({
    url: '/biz/admin/order/refund/delete',
    method: 'post',
    data: data
  })
}
